<script>
import PrivacyPolicyDisclaimer from './PrivacyPolicyDisclaimer';
import ResearcherSignupEmail from './ResearcherSignupEmail';
import ResearcherOAuth from './thirdPartySignups/ResearcherOAuth';
import responsiveMixin from '@/mixins/responsiveMixin';
import { helpers as notificationHelpers } from '@/store/modules/notifications';
import { helpers as referralHelpers } from '@/store/modules/referral';
import { helpers as researcherHelpers } from '@/store/modules/researcherSignup';
import { SHOW_SNACKBAR } from '@/store/types';
import _ from 'lodash';

export default {
  components: {
    ResearcherOAuth,
    PrivacyPolicyDisclaimer,
    ResearcherSignupEmail,
  },
  mixins: [responsiveMixin],
  data() {
    const params = new URLSearchParams(window.location.search);

    // Get pricing parameters from marketing pricing page
    const pricingParams = {
      ...(params.get('plan-type') && { planType: params.get('plan-type')}),
      ...(params.get('participant-type') && { participantType: params.get('participant-type')}),
    };

    if (pricingParams?.planType) {
      window.sessionStorage.setItem('planType', pricingParams.planType);
    }

    if (pricingParams?.participantType) {
      window.sessionStorage.setItem('participantType', pricingParams.participantType);
    }


    const authError = params.get('authError');
    return {
      authError,
    };
  },
  methods: {
    ...notificationHelpers.mapActions({ showSnackbar: SHOW_SNACKBAR }),
  },
  computed: {
    ...referralHelpers.mapState({ referrerName: 'referrerName' }),
    ...researcherHelpers.mapState({ invitation: 'invitation' }),
    researcherHeaderText() {
      const inviteCompany = _.get(this.invitation, 'name');
      if (inviteCompany) return `You've Been Invited to Join ${inviteCompany}`;
      if (this.referrerName)
        return `${this.referrerName} has invited you to join Respondent`;
      return 'Create a New Researcher Account';
    },
    researcherHeaderSubtext() {
      const inviteCompany = _.get(this.invitation, 'name');
      if (inviteCompany)
        return 'To accept your invitation, simply create your account and enjoy recruiting!';
      return 'Publish your project and recruit from over 100k verified professionals.';
    },
    desktopHeaderDisplaySize() {
      return _.isEmpty(this.invitation) && _.isEmpty(this.referrerName)
        ? 'display-4'
        : 'display-3';
    },
  },
  mounted() {
    if (this.authError) {
      this.showSnackbar({
        message: this.authError,
      });
    }
  },
};
</script>

<template>
  <div style="max-width: 502px">
    <h1
      :class="
        responsiveClasses({
          tablet: 'display-3 mb-4',
          desktop: `${desktopHeaderDisplaySize} mb-5`,
        })
      "
    >
      {{ researcherHeaderText }}
    </h1>
    <p class="mb-11">
      {{ researcherHeaderSubtext }}
    </p>
    <researcher-signup-email />
    <privacy-policy-disclaimer class="mb-9" />
    <researcher-o-auth provider="google" class="mb-5" />
    <researcher-o-auth provider="outlook" class="mb-10" />
  </div>
</template>
